export default {
    PART: "part",
    SYMBOL: "symbol",
    FOOTPRINT: "footprint",
    HDLSYMBOL: "hdl symbol",
    PADSTACK: "padstack",
    SHAPE: "shape",
    FLASH: "flash",
    MECHANICAL: "mechanical",
    FORMAT: "format",
    REUSEMODULE: "reuse module",
    COM: "com",
    FILE: "file"

}



// WEBPACK FOOTER //
// ./src/constants/LibraryTypes.js